import { Component } from '@angular/core';
import { FormGroup, FormControl, Validators, AbstractControl } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { provideDestroyService, injectDestroyService } from '@app/helpers';
import { ToastrService } from 'ngx-toastr';
import { takeUntil, tap } from 'rxjs';

import { UserService } from '@app/services';
import {
   CFDI4_PERSONS_TYPE,
   CFDI4_REGIMES,
   CFDI4_REGIME_USE_MAP,
   CFDI4_USES,
} from '@app/constants/cfdi';

@Component({
   selector: 'mnf-modal-fiscal-update',
   templateUrl: './modal-fiscal-update.component.html',
   providers: [provideDestroyService()],
   styleUrls: ['./modal-fiscal-update.component.scss'],
})
export class ModalFiscalUpdateComponent {
   private readonly destroy$ = injectDestroyService();

   /** Constantes */
   /** Tipo de persona fiscal */
   personType = CFDI4_PERSONS_TYPE;
   /** Arreglo de regimenes fiscales para personas fisicas y morales*/
   allFiscalRegimes = CFDI4_REGIMES;
   /** Arreglo de usos de CFDI */
   allCFDIUsages = CFDI4_USES;
   /** Variables locales para mostrar opciones filtradas */
   fiscalRegimes = [];
   cfdiUsages = [];

   /** Formulario de actualización de datos fiscales */
   fiscalDataForm = new FormGroup({
      personType: new FormControl('', Validators.compose([Validators.required])),
      zipCode: new FormControl('',
         Validators.compose([
            Validators.required,
            Validators.minLength(5),
            Validators.maxLength(5),
            Validators.pattern('[0-9]*'),
         ]),
      ),
      cfdiUse: new FormControl('', Validators.compose([Validators.required])),
      fiscalRegime: new FormControl('', Validators.compose([Validators.required])),
   });

   constructor(
      private modal: MatDialogRef<ModalFiscalUpdateComponent, { status: string }>,
      private userServ: UserService,
      private toaster: ToastrService
   ) {
      this.initObservablesForm();
   }


   /** Guarda los datos del formulario para actualizar los datos fiscales */
   saveCFDIInfo() {
      if (this.fiscalDataForm.valid) {
         const { zipCode, cfdiUse, fiscalRegime, personType } = this.fiscalDataForm.value;

         this.userServ.updateCFDIInfo(zipCode, cfdiUse, fiscalRegime, personType).subscribe({
            next: (b) => {
               this.toaster.success('Datos fiscales actualizados correctamente', 'Éxito');
               this.userServ.userNotificationsChange.next([{ type: 'update_fiscal_info_cfdi4', status: b.status }])
               this.modal.close(b);
            },
            error: () => {
               // this.modal.close();
               this.toaster.warning('No se lograron actualizar los datos fiscales', 'Error');
            }
         });
      }
   }

   /** Inicializa los observables del formulario */
   initObservablesForm() {
      this.fiscalDataForm.get('personType').valueChanges.pipe(
         takeUntil(this.destroy$),
         tap((value: string) => {
            const index = CFDI4_PERSONS_TYPE.findIndex(
               (personType) => personType.value === value
            );
            if (index >= 0) {
               this.fiscalRegimes = this.allFiscalRegimes[value];
            } else {
               this.fiscalRegimes = [];
            }
         })
      ).subscribe();

      this.fiscalDataForm.get('fiscalRegime').valueChanges.pipe(
         takeUntil(this.destroy$),
         tap((value: string) => {
            const regimeUsesValues = CFDI4_REGIME_USE_MAP[value];
            if (regimeUsesValues.length >= 0) {
               this.cfdiUsages = CFDI4_USES.filter((use) =>
                  regimeUsesValues.includes(use.value)
               );
            } else {
               this.cfdiUsages = [];
            }
         })
      ).subscribe();
   }
}
